import React, { useEffect, useState } from 'react'
import classes from "./style.module.scss";
import { Icons, Images } from '../../../../assets';
import TableWrapper from '../../../../component/TableWrapper';
import { useNavigate } from 'react-router-dom';
import Exported from '../../../../service/endpoints';
import request from '../../../../service';
import { saveLoadingState } from '../../../../redux/reducers/loadingSlice';
import { useDispatch } from 'react-redux';
import { Toast } from '../../../../service/toast';
import ConfirmationModal from '../../../../modalComponents/ConfirmationModal';
import Button from '../../../../component/Button';

const UserRetailRequest = (props) => {

    const { activeTab, searchInput, setViewData } = props
    const dispatch = useDispatch();
    const [page, setPage] = useState(1);
    const [userList, setUserList] = useState({});
    const [isLoading, setisLoading] = useState(false);
    const [sortConfig, setSortConfig] = useState(null);
    const [showDeletePopUp, setShowDeletePopUp] = useState(false)
    const [selectedId, setSelectedId] = useState(null)
    const [selectedRoleId, setSelectedRoleId] = useState(null)
    const [totalCount, setTotalCount] = useState(null)
    const [selectAll, setSelectAll] = useState(false);
    const [isGeneratingPdf, setIsGeneratingPdf] = useState(false);
    const [selectedUsers, setSelectedUsers] = useState([]);    
    const navigate = useNavigate()

    const userHeader = [
        { label: (
            <div className='flex justify-center align-middle gap-2'> 
                <p>
                {selectAll ? 'Deselect All' : 'Select All'}
                </p>
              <input 
                type="checkbox" 
                checked={selectAll}
                onChange={handleSelectAll}
              />
            </div>
          ) 
    },
        { label: 'S.No'},
        { label: 'User Name',},
        { label: 'Email',},
        { label: 'Current Points' },
        { label: 'Role' },
    ];

    useEffect(() => {
        setPage(1)
        setSortConfig(null)
        setSelectAll(false)
    }, [activeTab])

    useEffect(() => {
        getUserList()
        setSelectAll(false)
    }, [page, activeTab, searchInput, sortConfig])

    function handleSelectAll(e) {
        const checked = e.target.checked;
        setSelectAll(checked);
        
        if (checked) {
          // Select all users on current page, accounting for both data structures
          const allIds = userList?.result?.map(item => (item.user?.id || item.id)).filter(Boolean);
          setSelectedUsers(allIds);
        } else {
          // Deselect all
          setSelectedUsers([]);
        }
      }

    function handleSelectUser(e, userId) {
        const checked = e.target.checked;
        
        if (checked) {
          setSelectedUsers(prev => [...prev, userId]);
        } else {
          setSelectedUsers(prev => prev.filter(id => id !== userId));
        }
      }

    useEffect(() => {
        if (!userList?.result?.length) return;
        
        const allCurrentPageIds = userList.result
          .map(item => (item.user?.id || item.id))
          .filter(Boolean);
          
        const allSelected = allCurrentPageIds.every(id => 
          selectedUsers.includes(id)
        );
        
        setSelectAll(allSelected && allCurrentPageIds.length > 0);
      }, [selectedUsers, userList.result]);

    const getUserList = async () => {
      setisLoading(true);

      let url = `${Exported.Endpoints.manageUserReportbyUser}`;

      // Use different API endpoint when the tab is "By User"
      if (activeTab?.type !== "By Users") {
        url = Exported.Endpoints.manageUserReport;
      }

      let paramsObj = {
        page: page,
        limit: 10,
      };
      if (activeTab?.role) {
        paramsObj["role"] = activeTab?.role;
      }
    //   if (activeTab?.type) {
    //     paramsObj["type"] = activeTab?.type;
    //   }
      if (activeTab?.isApprovedByFilter) {
        paramsObj["isApprovedByFilter"] = activeTab?.isApprovedByFilter;
      }
      if (searchInput && searchInput !== "") {
        paramsObj["search"] = searchInput;
      }
      if (activeTab?.startDate) {
        paramsObj["fromDate"] = activeTab.startDate;
      }
      if (activeTab?.endDate) {
        paramsObj["toDate"] = activeTab.endDate;
      }
      if (activeTab?.points) {
        paramsObj["byPoints"] = true;
      }
      if (sortConfig) {
        paramsObj["sort"] = sortConfig?.key;
        paramsObj["sortOrder"] = sortConfig?.direction;
      }
      await request({
        url: url,
        params: { ...paramsObj },
      })
        .then((res) => {
          if (res?.data?.status) {
            const obj = {
              result: res?.data?.data?.list,
              pageMeta: res?.data?.data?.pageMeta,
            };
            setUserList(obj);
            setTotalCount(res?.data?.data?.pageMeta?.total);
          }
        })
        .catch((err) => {
          console.log(err, "err");
          Toast({
            type: "error",
            message: "Unable to process the request!..",
          });
        });
      setisLoading(false);
    }
   
    const handleData = (keyValue, defaultValue, className = '') => {
      return (
          <td className={`${className}`}>{keyValue !== null && keyValue !== undefined ? keyValue : defaultValue}</td>
      )
  };

    const deleteProduct = async () => {
        dispatch(saveLoadingState(true))
        let url = `${Exported.Endpoints.common}/${selectedId}`
        const requestData = {
            id: selectedId,
        }
        await request({
            url: url,
            method: Exported.APIMethods.DELETE,
            data: requestData
        }).then(async (res) => {
            if (res?.data?.status) {
                await getUserList()
                setShowDeletePopUp(false)
                Toast({
                    type: 'success',
                    message: 'Record deleted successfully!...'
                })
            }
        }).catch((err) => {
            console.log(err, "err")
            Toast({
                type: 'error',
                message: 'Unable to process the request!..'
            })
        })
        dispatch(saveLoadingState(false))
    }

    const handleClose = () => {
        setShowDeletePopUp(false)
    }

    const generatePdf = async () => {
        setIsGeneratingPdf(true);
        
        try {
            // Determine which endpoint to use based on the active tab
            let url = activeTab?.points
              ? Exported.Endpoints.manageUserPDFbyPoints
              : activeTab?.startDate && activeTab?.endDate
              ? Exported.Endpoints.manageUserReportdownloadbyDate
              : Exported.Endpoints.manageUserPDF;          
            
            let requestData = {};
            
            // Add selected userIds if any are selected
            if (selectedUsers.length > 0) {
                requestData.userIds = selectedUsers;  
            }
            
            // Add specific parameters based on the active tab
            if (activeTab?.points) {
                // For "By Points" tab
                if (activeTab?.startDate && activeTab?.endDate) {
                    requestData.fromDate = activeTab.startDate;
                    requestData.toDate = activeTab.endDate;
                }
            } else if (activeTab?.startDate && activeTab?.endDate) {
                // For "By Date" tab
                requestData.fromDate = activeTab.startDate;
                requestData.toDate = activeTab.endDate;
            }
                  
            await request({
                url: url,
                method: Exported.APIMethods.POST,
                data: requestData,  
                responseType: 'arraybuffer',
            }).then((res) => {
                if (res?.data) {
                    const blob = new Blob([res.data], { 
                        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' 
                    });
                    const downloadUrl = window.URL.createObjectURL(blob);
                    
                    // Create an anchor element and trigger download
                    const link = document.createElement('a');
                    link.href = downloadUrl;
    
                    // Name the file appropriately based on the tab
                    let fileName = activeTab?.points 
                        ? 'points_report.xlsx' 
                        : activeTab?.startDate 
                            ? 'date_report.xlsx' 
                            : 'users_report.xlsx';
    
                    link.download = fileName;
                    link.click();
    
                    // Clean up
                    window.URL.revokeObjectURL(downloadUrl);

                    Toast({
                        type: 'success',
                        message: 'Report generated successfully!'
                    });
                }
            }).catch((err) => {
                console.log(err, "err");
                Toast({
                    type: 'error',
                    message: 'Failed to generate Report. Please try again.'
                });
            });
        } finally {
            setIsGeneratingPdf(false);
        }
    };

    return (
      <div className={`eventWrapper`}>
        <div className='flex justify-between align-middle'>
        <div className="countContainer">
          <p>Total Count: {totalCount}</p>
        </div>
        <div className="actions">
          <Button
            disabled={isGeneratingPdf}
            text= {selectedUsers.length > 0 ? "Generate Selected Users Report" : "Download All"}
            onClick={generatePdf}
            style={{     
                lineHeight: "normal",
                height: "40px",
                padding: "0px 20px",
                fontSize: "16px", }}
            />
        </div>
        </div>
        <div className={`mt-2 mb-5 ${classes.retailTableWrapper}`}>
          <TableWrapper
            headerDetails={userHeader}
            pageMeta={userList?.pageMeta}
            handlePageChange={setPage}
            listLength={userList?.result || []}
            isLoading={isLoading}
            sortConfig={sortConfig}
            setSortConfig={setSortConfig}
          >
            {userList?.result?.map((item, index) => {
                const userData = item.user || item;
                const {
                    id = "",
                    email = "",
                    name = userData.firstName && userData.lastName 
                      ? `${userData.firstName} ${userData.lastName}`
                      : "",
                      points = userData.points || 0,
                    userRole = userData.roleId === 2 ? "Retailer" : userData.roleId === 3 ? "Mechanic" : "Authorised user",
                  } = userData;
              return (
                <tr key={`${id}-${index}`}>
                  <td className="check-button">
                    <div className="flex items-right justify-right ml-9">
                      <input
                        type="checkbox"
                        checked={selectedUsers.includes(id)}
                        onChange={(e) => handleSelectUser(e, id)}
                        className="cursor-pointer"
                      />
                    </div>
                  </td>
                  {handleData(
                    (page - 1) * 10 + (index + 1),
                    "-",
                    "text-center"
                  )}
                  {handleData(name, "-", "text-center")}
                  {handleData(email, "-", "text-center")}
                  {handleData(points, "-", "text-center")}
                  {handleData(userRole, "-", "text-center")}
                </tr>
              );
            })}
          </TableWrapper>
        </div>
        {showDeletePopUp ? (
          <ConfirmationModal
            isOpen={showDeletePopUp}
            handleSuccess={deleteProduct}
            closePopUp={handleClose}
            warningText={"Confirmation"}
            modalText={
              selectedRoleId === 2
                ? "If this Retailer is deleted, all the Authorized Users associated with this Retailer will be deleted."
                : "Are you sure you want to delete this user?"
            }
            confirmText={"Yes"}
            cancelText={"No"}
            primaryBtnConfirm={false}
          />
        ) : null}
      </div>
    );
}

export default UserRetailRequest


// const redirectUserDetails = (id, item) => {
//     // setViewData(item)
//     navigate(`?id=${id}`)
// }

// const downloadActivity = async (id, item) => {
//     let url = Exported.Endpoints.scannedActivity;

//     let paramsObj = {
//         page: page,
//         limit: 10,
//         export_excel: true,
//         userId: id,
//     };

//     await request({
//         url: url,
//         method: Exported.APIMethods.GET,
//         params: { ...paramsObj },
//         responseType: 'arraybuffer',  
//     })
//         .then((res) => {
//             if (res?.data && res?.data) {
//                 const blob = new Blob([res?.data], {
//                     type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
//                 });  
//                 const downloadUrl = window.URL.createObjectURL(blob);
//                 const link = document.createElement('a');
//                 link.href = downloadUrl;
//                 link.download = `${item.username}_activity.xlsx`;  
//                 link.click(); 
//                 window.URL.revokeObjectURL(downloadUrl);
//             } else {
//                 Toast({
//                     type: 'error',
//                     message: 'Invalid file data.',
//                 });
//             }
//         })
//         .catch((err) => {
//             console.log(err, 'err');
//             Toast({
//                 type: 'error',
//                 message: 'Unable to process the request!..',
//             });
//         });
// };

// const handleDelete = (id, roleId) => {
//     setShowDeletePopUp(true)
//     setSelectedId(id)
//     setSelectedRoleId(roleId)
// }